import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project, ProjectResource, Role } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  projectResources: Identifiable<ProjectResource>[];
  retrieveProjectsRoles(
    request: Boundaries["retrieveProjectsRoles"]["request"],
  ): void;
}

function useRetrieveProjectsRoles(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveProjectsRolesRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveProjectsRolesRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveProjectsRolesRequestFailure,
    ),
    projectResources: useSelector(selector.getProjectsRoles),
    retrieveProjectsRoles: core.retrieveProjectsRoles,
  };
}

export { useRetrieveProjectsRoles };
